













import AppText from '@berlin-front/common/components/elements/AppText';
import { defineComponent, computed } from '@vue/composition-api';
// eslint-disable-next-line import/extensions
import { bemx } from '@berlin-front/common/utils';

/**
 * アコーディオン
 */
export default defineComponent({
  name: 'AppAccordionPanel',

  components: {
    AppText,
  },

  props: {
    header: {
      type: String,
      default: '',
    },
  },

  setup() {
    const className = computed(() => bemx('AppAccordionPanel'));
    return {
      className,
    };
  },
});
